const SET_TOAST = 'SET_TOAST';

const DESTROY_TOAST = 'DESTROY_TOAST';

const setError = ({ message }) => ({
  type: SET_TOAST,
  payload: {
    message,
    type: 'error'
  }
});

const destroyToast = () => ({
  type: DESTROY_TOAST
});

export {
  SET_TOAST,
  DESTROY_TOAST,
  setError,
  destroyToast
};
